import {
  FETCH_ALL_CUSTOMER_APPOINTMENT,
  FETCH_ALL_CUSTOMER_APPOINTMENT_SUCCESS,
  CANCEL_CUSTOMER_APPOINTMENT,
  CANCEL_CUSTOMER_APPOINTMENT_SUCCESS
} from "../constants/ActionTypes";

export const fetchAllCustomerAppointment = () => ({
  type: FETCH_ALL_CUSTOMER_APPOINTMENT
});

export const fetchAllCustomerAppointmentSuccess = payload => ({
  type: FETCH_ALL_CUSTOMER_APPOINTMENT_SUCCESS,
  payload,
});

export const cancelCustomerAppointment = payload => ({
  type: CANCEL_CUSTOMER_APPOINTMENT,
  payload,
});

export const cancelCustomerAppointmentSuccess = payload => ({
  type: CANCEL_CUSTOMER_APPOINTMENT_SUCCESS,
  payload,
});


// WEBPACK FOOTER //
// ./actions/CustomerAppoointment.js